(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.mobile-nav-panel a');
    if (!link) return;
    link.closest('.mobile-nav')?.removeAttribute('open');
  });
  } catch(e) { console.error(e); }
})();

})();
